export default "__VITE_ASSET__35a4d57f__"